import { styled } from '@mui/material';

export const Input = styled('input', {
    shouldForwardProp: prop =>
        prop !== 'startAdornmentWidth' &&
        prop !== 'endAdornmentWidth' &&
        prop !== 'basePadding' &&
        prop !== 'sx',
})<{
    startAdornmentWidth?: number;
    endAdornmentWidth?: number;
    basePadding?: number;
}>(({ theme, startAdornmentWidth, endAdornmentWidth, basePadding = 12 }) => ({
    'width': 'inherit',
    'height': 'inherit',
    'border': 'none',
    'backgroundColor': 'transparent',
    'color': theme.palette.text.primary,
    'fontSize': theme.typography.body1.fontSize,
    'fontFamily': theme.typography.fontFamily,
    'fontWeight': 400,

    'paddingLeft': Math.max(basePadding, startAdornmentWidth || 0),
    'paddingRight': Math.max(basePadding, endAdornmentWidth || 0),

    '&:disabled': {
        color: theme.palette.text.disabled,
        fontWeight: 500,
        cursor: 'auto !important',
    },
    '&::placeholder': {
        color: theme.palette.text.hint,
    },

}));
